import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { raDetailState } from "../state";
import BillingOwnerInfoPerson from "./masks/BillingOwnerInfoPerson";
import BillingOwnerInfoCompany from "./masks/BillingOwnerInfoCompany";
import _ from 'underscore';

import { useRecoilState } from "recoil";
import { useQueryClient } from '@tanstack/react-query'
import { CREDIT_TYPE_VALUES } from "../../create-ra/ra-filling/config";
import { isRetail } from "../../utils";

const BillingOwnersInfo = () => {
    const {t} = useTranslation(['network', 'translation']);

    const queryClient = useQueryClient();

    queryClient.getQueriesData<any>(['ntw_legal_entities']);

    const [raDetail] = useRecoilState(raDetailState);
    
    const hasSecondBo = isRetail(raDetail?.bookingDetail?.rentalType) || [CREDIT_TYPE_VALUES.PARTIAL_CREDIT].includes(raDetail?.financialInfo?.creditType);

    const firstBoPerson = _.isEmpty(raDetail?.billingOwnerInfo?.invoiceOwner?.companyName);
    const secondBoPerson = _.isEmpty(raDetail?.billingOwnerInfo?.invoiceOwnerSecondary?.companyName);


    //console.log('BillingOwnersInfo raDetail: ' + JSON.stringify(raDetail));
   //console.log('BillingOwnersInfo raDetail: ' + JSON.stringify(raDetail?.billingOwnerInfo));
    

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"bodyLarge"}>
                    {t('raDetail.billingOwnerInfo.accordion.title.first')}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Typography variant={"bodyLarge"}>
                    {t('raDetail.billingOwnerInfo.accordion.subtitle.first')}
                </Typography>

                {firstBoPerson && <BillingOwnerInfoPerson boType="first" />}
                {!firstBoPerson && <BillingOwnerInfoCompany boType="first" />}
            </AccordionDetails>

            {
                hasSecondBo && (
                <AccordionDetails>
                    <Typography variant={"bodyLarge"}>
                        {t('raDetail.billingOwnerInfo.accordion.subtitle.second')}
                    </Typography>
                    {secondBoPerson && <BillingOwnerInfoPerson boType="second" />}
                    {!secondBoPerson && <BillingOwnerInfoCompany boType="second" />}
                </AccordionDetails>
            )}
        </Accordion>
    );
}

export default BillingOwnersInfo;